export class HomepageSixense {
  /**
   *
   */
  public organisations: number | null = null;

  /**
   *
   */
  public projects: number | null = null;

  /**
   *
   */
  public users: number | null = null;
}
